import { useBackLink } from 'pages/Index';

export default function RecommendationEducation() {
  const { backLink } = useBackLink();

  return (
    <div className="narrow-page education">
      {backLink}
      <h2>Om Hänvisning</h2>
      <h3>Vad är blodtryck, högt blodtryck och hypertoni?</h3>
      <p>
        Här har vi samlat grundläggande information om högt blodtryck och hypertoni och hur många som är drabbade och
        vad det innebär.
      </p>
      <p>
        <a href="https://friska.se/om-blodtryck-h%c3%b6gt-blodtryck-och-hypertoni/" target="_blank" rel="noreferrer">
          Ladda ner pdf.
        </a>
      </p>
      <h3>Om Friska</h3>
      <p>
        <a href="https://friska.se/om-oss/" target="_blank">
          Läs mer om tjänsten.
        </a>
      </p>
      <h3>Om hänvisning</h3>
      <p>Vilka som kan bli hänvisade och hur du gör i Partnerportalen.</p>
      <p>
        <a href="https://friska.se/app/uploads/2026/06/Utbildning-Hanvisning-2026.pdf" target="_blank" rel="noreferrer">
          Ladda ner pdf.
        </a>
      </p>
      <h3>Fysisk undersökning med digitalt stetoskop</h3>
      <p>
        <a href="https://friska.se/utbildning-digitalt-stetoskop-och-btd/" target="_blank" rel="noreferrer">
          Ladda ner pdf.
        </a>
      </p>
      <h3>Vanliga frågor och svar</h3>
      <p>
        <a href="https://friska.se/vanliga-fragor-och-svar-om-hanvisning/" target="_blank" rel="noreferrer">
          Vanliga frågor och svar om hänvisning.
        </a>
      </p>
      <h3>Lathund om hänvisning</h3>
      <p>
        <a
          href="https://friska.se/app/uploads/2026/06/Lathund-Blodtrycksdoktorn-2026.pdf"
          target="_blank"
          rel="noreferrer"
        >
          Ladda ner pdf.
        </a>
      </p>
      <h3>Länk till integritetspolicy</h3>
      <p>
        <a href="https://friska.se/integritetspolicy/" target="_blank" rel="noreferrer">
          Friskas integritetspolicy
        </a>
      </p>
      <h3>Support för vårdgivare</h3>
      <p>
        Du som vårdgivare når supporten via <a href="mailto:support@friska.se">support@friska.se</a> eller via
        0480-797960, uppge knappval 2 för partners. Du hittar även kontaktuppgifterna direkt i Partnerportalen uppe i
        högra hörnet.
      </p>
      <h3>Support för patienter</h3>
      <p>
        Hänvisa patienten till supportchatten i appen Friska. Det går även bra att mejla patientsupporten på
        support@friska.se.
      </p>
    </div>
  );
}
